import { ChangeDetectionStrategy, Component, Inject, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DragStore } from 'src/app/store/drag-store';
import { GlobalStore } from 'src/app/store/global-store';
import { Observable } from 'rxjs';
import { ExposureFieldDto } from 'src/app/models/exposureField';
import { environment } from 'src/environment';
import { toSignal } from '@angular/core/rxjs-interop';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';


@Component({
    selector: 'que-add-api-name-field',
    imports: [CommonModule, TranslateDirective, TranslatePipe, ReactiveFormsModule, OverlayModule],
    templateUrl: './add-api-name-field.component.html',
    styleUrls: ['./add-api-name-field.component.scss'],
    providers: [DragStore],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddApiNameFieldComponent {

  fieldName = new FormControl<number | null>(this.data?.id ?? null, [Validators.required]);
  isEditMode = this.data?.isEditMode ?? false;
  exposureFields = toSignal(inject(GlobalStore).exposureFields$, { initialValue: [] });
  lang = environment.lang;
  isMenuOpen = false;
  
  readonly positonArea = [{
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  }] as ConnectedPosition[];

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: { id?: number, isEditMode?: boolean }, private readonly dialogRef: MatDialogRef<AddApiNameFieldComponent>) {
    dialogRef.disableClose = true;
  }

  getFieldName(field: ExposureFieldDto): string {
    return this.lang === 'he' ? field.fieldName : (field.fieldNameEn || field.fieldName);
  }

  getSelectedFieldName(): string {
    const selectedField = this.exposureFields().find(f => f.id === this.fieldName.value);
    return selectedField ? this.getFieldName(selectedField) : '';
  }

  selectField(id: number) {
    this.fieldName.setValue(id);
    this.isMenuOpen = false;
  }

  cancel() {
    this.dialogRef.close(this.isEditMode ? null : undefined);
  }
  remove() {
    this.dialogRef.close(undefined);
  }
  save() {
    this.dialogRef.close(this.fieldName.value);
  }

}
